<template>
  <span class="voice-icon" :class="{'animate': playing, 'right': direction == 'right'}">
    <div class="cricle"></div>
    <div class="cricle"></div>
    <div class="cricle"></div>
  </span>
</template>

<style lang="less" scoped>
  .voice-icon{
    width: 18px;
    height: 18px;
    position: relative;
    overflow: hidden;
    transform-origin: 50% 50%;
    transform: rotate(-45deg);
    .cricle{
      border-radius: 50%;
      border: 2px solid #333;
      position: absolute;
      // &:first-child{
      //   width: 200%;
      //   height: 200%;
      // }
      &:first-child{
        right: 0%;
        bottom: 0;
        transform: translate(50%, 50%);
        width: 150%;
        height: 150%;
      }
      &:nth-child(2){
        right: 0%;
        width: 100%;
        transform: translate(50%, 50%);
        height: 100%;
      }
      &:nth-child(3){
        bottom: 0;
        background-color: #333;
        height: 50%;
        right: 0%;
        width: 50%;
        transform: translate(50%,50%);
      }
    }
    &.animate{
      .cricle{
        &:first-child{
          animation: fadeOutLine 1.5s steps(1) infinite;
        }
        &:nth-child(2){
          animation: fadeInnerLine 1.5s steps(1) infinite;
        }
      }
    }
    &.right{
      transform: rotate(135deg);
    }
  }
  @keyframes fadeOutLine {
    0%{opacity:0}
    30%{opacity:1}
    70%{opacity:0}
  }
  @keyframes fadeInnerLine {
    0%{opacity:0}
    15%{opacity:1}
    85%{opacity:0}
  }
</style>

<script type="text/javascript">
  export default {
    props: {
      playing: {
        type: Boolean,
        default: false
      },
      direction: {
        type: String,
        default: 'left',
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Common/voiceIcon.vue